import { NgModule, CUSTOM_ELEMENTS_SCHEMA }                from '@angular/core';
import { BrowserModule }           from '@angular/platform-browser';
import { HttpModule, JsonpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// Modules
import { SharedModule }            from './shared/shared.module';
import { AppRoutingModule }        from './app-routing.module';
import { DashboardModule }         from './dashboard/dashboard.module';
import { GlobalSettingsModule }    from './global-settings/global-settings.module';
import { EditionsModule }          from './editions/editions.module';
import { SubscriptionsModule }     from './subscriptions/subscriptions.module';
// Components
import { AppComponent }            from './app.component';
import { NavigationComponent }     from './navigation/navigation.component';
import { GlobalUserComponent }     from './global-user/global-user.component';
import { SearchResultsComponent }  from './search-results/search-results.component';
import { AccountSettingsComponent } from './global-user/account-settings/account-settings.component';
import { UnauthorizedComponent }   from './global-user/unauthorized/unauthorized.component';
// Services
import { EditionListService }      from './editions/edition.service';
import { DownloadNotificationService } from './root-services/download-notification.service'
import { ApiService }              from './root-services/api.service';
import { SubscriptionsService }    from './subscriptions/subscriptions.service';
import { CurrentUserService }      from './shared/services/current-user.service';
import { PermissionsService }      from './shared/services/permissions.service';
import { GroupService }            from './dashboard/program-list/group.service';
import { FieldManualService }      from './dashboard/program-list/field-manual.service';
import { ProgramService }          from './shared/services/program.service';

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    GlobalUserComponent,
    SearchResultsComponent,
    AccountSettingsComponent,
    UnauthorizedComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    JsonpModule,
    SharedModule,
    AppRoutingModule,
    DashboardModule,
    GlobalSettingsModule,
    EditionsModule,
    SubscriptionsModule,
    BrowserAnimationsModule
  ],
  providers: [
    EditionListService, // to make sure we always get the same one injected
    ApiService,
    DownloadNotificationService,
    SubscriptionsService,
    CurrentUserService,
    PermissionsService,
    ProgramService,
    FieldManualService,
    GroupService,
  ],
  bootstrap: [ AppComponent ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})

export class AppModule { }



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/app.module.ts